<template>
    <div>
        <div class="container-fluid mt-45">
            <div class="row">
                <div class="col">
                    <p class="h2 mt-0 mb-1">Test Kit Assigned</p>
                </div>
            </div>
        </div>
    
        <div class="container mt-4 mt-md-5">
            <div class="row justify-content-center">
                <div class="col-lg-6 col-md-8">
                    <div class="card border-0 shadow">
                        <div class="card-body text-center p-4 p-md-5">
                            <img src="@/assets/images/icons/green-tick.svg" width="65" alt="device assigned">
                            
                            <div v-if="$route.params.patientName != null">
                                <h2 class="mt-4">Test Kit has been assigned to</h2>
        
                                <div class="assigned-to-box mt-4">
                                    {{ $route.params.patientName }}
                                </div>
                            </div>
                            
                            <div class="mt-45">
                                <button @click="returnToDashboard()" class="btn btn-yellow btn-block btn-lg lg-shadow px-0">Return to Dashboard</button>
                                <button @click="assignAnotherTest()" class="btn btn-success btn-block btn-lg lg-shadow mt-4 px-0">Assign another Test Kit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DeviceAssigned',

    mounted() {
        if(!this.$route.params.patientName) return this.$router.push({name: 'Dashboard'})
    },

    methods: {
        returnToDashboard() {            
            return this.$router.push({name: 'Dashboard'})
        },

        assignAnotherTest() {            
            return this.$router.push({name: 'CreateOrSelectPatient'})
        }
    }
}
</script>